import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import SelectionHeader from './SelectionHeader';
import OrderListTable from './OrderListTable';
import moment from 'moment';
import { DAYS, EMPTY_STRING, EMPTY_COUNT, ERROR, FIRST_INDEX, DATE_FORMAT, HOUR_MINUTE_FORMAT, MOBILE_NUMBER_INPUT, MOBILE_ORDERS_LIST, ERROR_BEHIND_DATA, HALF_HYPHEN, DEFAULT_TIMEZONE, SHORT_TRUE } from '../../../utils/constants';
import { mobileOrdersOperations, mobileOrdersSelectors } from "../MobileOrders/state";
import { authOperations } from "../Login/state";
import ErrorAlert from '../../components/ErrorAlert';
import { ORDER_MONTHLY } from './routes';
import { isNullOrEmpty } from '../../../utils/common';
import { ERROR_ORDER_ITEMS_DAILY_UPDATE, RELOAD_MASTER_UPDATED, ERROR_ORDER_ITEMS_DAILY_RETRIEVE } from '../../../utils/messages';
import SuccessAlert from '../../components/SuccessAlert';
import Confirmation from '../../components/Confirmation';
import { isNullOrUndefined } from '../../../../node_modules/util';
import $ from 'jquery';

class OrderList extends Component {
    constructor(props) {
        super(props)

        let defaultDate = moment().tz(DEFAULT_TIMEZONE);

        if(!isNullOrEmpty(props.filterDate)){
            defaultDate = moment(props.filterDate).tz(DEFAULT_TIMEZONE);
        }

        this.state = {
            filterDate: defaultDate,
            formList: props.list,
            deliveryDttm: EMPTY_STRING,
            error: [],
            success: [],
            predictions: [],
            reload: false,
            disableInput: true
        };
    }

    componentDidMount() {

        this.props.setMobilePage(MOBILE_ORDERS_LIST);
        if(isNullOrEmpty(this.props.filterDate) || undefined === this.props.filterDate) {
            this.props.fetchActiveDelivery(this.setFetchParams())
            .then(() => {
                this.setState({ filterDate: this.props.filterDate,formList: this.props.list},
                    () => {
                        this.setPrediction();
                        this.setState({disableInput: this.isDisabled()});
                    });
            })
            .catch(() => {
                this.props.clearList();
                this.setState({ error: [ERROR_ORDER_ITEMS_DAILY_RETRIEVE], success: [], formList: [] })
            });
        }else{
            this.loadData();
        }
    }

    /* setPrediction() {
        this.setState({ predictions: [] });

        this.state.formList.map((row, index) =>
            mobileOrdersSelectors.calculateDailyEstimate(row, this.state.filterDate)
                .then((result) => this.setState(prevState => ({
                    predictions: [...prevState.predictions, result]
                }), ()=>{
                    row.orderedProducts = (HALF_HYPHEN !== this.state.predictions[index] && isNullOrUndefined(row.orderedProducts)) ? this.state.predictions[index] : row.orderedProducts
                })
                )
                .catch(()=>{
                    this.setState({predictions: []});
                })
        )
    } */
    setPrediction() {
        this.setState({ predictions: [] });

        let newStateList = Object.assign([], this.state.formList);

        this.state.formList.map((row, index) => {
            mobileOrdersSelectors.calculateDailyEstimate(row, this.state.filterDate)
                .then((result) => {
                    let productRow = newStateList.filter(item => item.productCode === result.productCode);
                    productRow[0].orderedProducts = (SHORT_TRUE === productRow[0].displayForecast && isNullOrUndefined(productRow[0].orderedProducts))  ? result.prediction : productRow[0].orderedProducts
                    
                    if(productRow[0].orderedProducts === HALF_HYPHEN){
                        productRow[0].orderedProducts = null;
                    }

                    productRow[0].prediction = result.prediction;
                    this.setState({ formList: newStateList })
                })
                .catch(() => {
                    this.setState({ predictions: [] });
                })

            
        }
        )
    }

    loadData() {
        this.props.setFilterDate(moment(this.state.filterDate).tz(DEFAULT_TIMEZONE));
        
        this.props.fetchDefault(this.setFetchParams())
            .then(() => {
                this.setState({
                    formList: this.props.list,
                    error: []
                }, () => {
                    this.setPrediction();
                    this.setState({disableInput: this.isDisabled()});
                });
            }).catch(() => {
                this.props.clearList();
                this.setState({ error: [ERROR_ORDER_ITEMS_DAILY_RETRIEVE], success: [], formList: [] })
            });
    }

    setFetchParams = () => {
        return {
            proposalId: EMPTY_STRING,
            deliveryDttm: this.state.filterDate && new Date(this.state.filterDate).getTime(),
            shopMainNumber: this.props.user.mainNumber,
            shopBranchNumber: this.props.user.branchNumber,
            userCode: this.props.loginId,
            isMobile: true
        }
    }

    handleInputChange = (e) => {
        let that = this;
        let input_id = e.target.id;
        this.setOrder(input_id, e.target.value);

        $(function() {
            $(`#${input_id}`).on('input', function() {
                if(EMPTY_COUNT !== this.value && EMPTY_STRING !== this.value){
                    this.value = this.value
                        .replace(/\b(0(?!\b))+/g, "")
                        .replace(/(^[\d]{10})[\d]/g, '$1') 
                        .replace(/(\..*)\./g, '')  
                }

                that.setOrder(input_id, this.value);
            });
        });
    }

    setOrder = (id, value) =>{
        let newAmt = EMPTY_STRING === value ? EMPTY_STRING : Number(value);
        let newStateList = Object.assign({}, this.state.formList);
        let newItem = newStateList[id]
        newItem.orderedProducts = newAmt;
        
        this.setState({ list: newStateList });
    }

    handleDateChange = (name, customFormat, date) => {
        this.setState({ [name]: date, success: [] }, () => this.loadData());
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    setNextDate = () => {
        let nextDate = moment(this.state.filterDate).add(1, DAYS).tz(DEFAULT_TIMEZONE);
        this.setState({ filterDate: nextDate, success: [] }, () => this.loadData());
    }

    setPrevDate = () => {
        let prevDate = moment(this.state.filterDate).subtract(1, DAYS).tz(DEFAULT_TIMEZONE);
        this.setState({ filterDate: prevDate, success: [] }, () => this.loadData());
    }

    showReload = () => {
        return this.state.reload && (
            <Confirmation
                message={RELOAD_MASTER_UPDATED}
                showConfirmation={true}
                buttons={[
                    { label: "OK", action: ()=>{window.location.reload()} },
                ]}
            />
        );
    }

    handleSubmit = () => {
        let errorList = mobileOrdersSelectors.validate(this.state.formList, true);

        if (EMPTY_COUNT < errorList.length) {
            this.setState({ error: errorList, success: [] });
        } else {
            let updateList = this.state.formList.filter((order)=> !isNullOrEmpty(order.orderedProducts));
            this.props.editOrders(updateList, this.props.loginId, this.state.filterDate)
                .then((result) => {
                    if (ERROR === result.status) {
                        if (ERROR_BEHIND_DATA === result.data) {
                            this.setState({ reload: true});
                        } else {
                            this.setState({ error: [result.message], success: [] });
                        }
                    } else {
                        this.setState({ success: [result.message], error: [] });
                        this.loadData();
                    }
                }).catch(() => this.setState({ error: [ERROR_ORDER_ITEMS_DAILY_UPDATE], success: [] }))
        }
        
    }

    isDisabled = () => {
        let result = true;

        if (EMPTY_COUNT < this.props.list.length) {
            let orderDate = moment(moment().add(this.props.list[FIRST_INDEX].proposalDeadlineCount, DAYS).format(DATE_FORMAT))
            let selectedDate = moment(moment(this.state.filterDate).format(DATE_FORMAT));

            if (selectedDate.isAfter(orderDate)
                || (selectedDate.isSame(orderDate)
                    && Number(this.props.list[FIRST_INDEX].deadlineTime) >= moment().format(HOUR_MINUTE_FORMAT))
            ) {
                result = false;
            }
        }

        return result;
    }

    hasNoInput = () =>{
        let result = true;

        let formInputs = this.state.formList.filter((order)=> !isNullOrEmpty(order.orderedProducts));

        if(!isNullOrUndefined(formInputs) && EMPTY_COUNT < formInputs.length){
            result = false;
        }

        return result;
    }

    viewMonthlyOrders = (data, event) => {
        if (EMPTY_COUNT > event.target.className.indexOf(MOBILE_NUMBER_INPUT)) {
            this.props.history.push({
                pathname: ORDER_MONTHLY + `/${data.productCode}`,
                state: { details: data }
            });
        }
    }


    render() {
        return (
            <Grid className="mobile-container">
                <Grid>
                    {this.showReload()}
                    
                    <ErrorAlert errors={this.state.error} />
                    <SuccessAlert success={this.state.success}/>

                    <SelectionHeader
                        handleDateChangeRaw={this.handleDateChangeRaw}
                        handleDateChange={this.handleDateChange}
                        handleSubmit={this.handleSubmit}
                        formList={this.state.formList}
                        filterDate={this.state.filterDate}
                        setNextDate={this.setNextDate}
                        setPrevDate={this.setPrevDate}
                        disableSubmit={this.state.disableInput}
                        noInput={this.hasNoInput()}
                    />
                    
                    <OrderListTable
                        {...this.props}
                        list={this.state.formList}
                        handleInputChange={this.handleInputChange}
                        filterDate={this.state.filterDate}
                        disableInput={this.state.disableInput}
                        viewMonthlyOrders={this.viewMonthlyOrders}
                        predictions={this.state.predictions}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filterDate: state.mobileOrders.filterDate,
        loginId: state.auth.credentials.user_cd,
        user: state.auth.partnerCodes,
        list: state.mobileOrders.list
    }
};

const mapDispatchToProps = {
    fetchActiveDelivery: mobileOrdersOperations.fetchActiveDelivery,
    fetchDefault: mobileOrdersOperations.fetchDefault,
    fetchPredictionValues: mobileOrdersOperations.fetchPredictionValues,
    fetchPredictionValuesDaily: mobileOrdersOperations.fetchPredictionValuesDaily,
    fetchPredictionValuesMonthly: mobileOrdersOperations.fetchPredictionValuesMonthly,
    editOrders: mobileOrdersOperations.updateOrders,
    setMobilePage: authOperations.setMobilePage,
    clearList: mobileOrdersOperations.clearList,
    setFilterDate: mobileOrdersOperations.setFilterDate
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderList);